// extracted by mini-css-extract-plugin
export default {"search-box":"bb_QB","search-box__input":"bb_QC form-control","search-box__icon":"bb_QD ml-2"};